<script lang="ts">
  import type { ProductVariant } from '@agapi/mlc-core';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import { css } from '@agapi/ui/panda/css';
  import * as m from '$lib/parachute/messages';

  import { ProductCard } from '../../../components';
  import { similarProductsStyles } from './product.styles';

  const { similarProducts, css: cssProp }: { similarProducts: ProductVariant[]; css: SystemStyleObject } = $props();

  const classes = similarProductsStyles.raw({});
</script>

<div class={css(classes.container, cssProp)}>
  <h2 class={css(classes.title)}>{m.similarProducts()}</h2>
  <div class={css(classes.productList)}>
    {#each similarProducts as variant}
      <ProductCard.Small
        css={{
          minWidth: { base: '100%', lg: '40%' }
        }}
        product={variant}
        buttonLabel={m.buy()}
      />
    {/each}
  </div>
</div>
